var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrayonIQLogosNegativeEmpowerIQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "88.1015625 87.33984375 972.8671875 205.30859375",
    style: {
      enableBackground: "new 0 0 1149.08 377.95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#FFFFFF;}\t.st1{fill:none;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 818.81,
    y: 195.4,
    className: "st0",
    width: 12.82,
    height: 15.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M965.29,145.77c-17.82,0-36.93,12.05-36.93,38.71S947.47,223,965.29,223c4.31,0,8.63-0.74,12.99-2.18   l-18.74-20.5l18.89-15.85l18.74,20.53c3.06-5.6,4.87-12.24,4.87-20.53C1002.04,157.82,982.96,145.77,965.29,145.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1031.59,184.66c0-40.51-30.43-66.61-66.29-66.61c-36.04,0-66.48,26.1-66.48,66.61   c0,40.33,30.43,66.43,66.48,66.43c11.88,0,23.42-2.88,33.13-8.29l15.68,17.29l18.74-15.85l-15.68-17.1   C1026.16,216.14,1031.59,201.77,1031.59,184.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1031.59,184.66c0-40.51-30.43-66.61-66.29-66.61c-36.04,0-66.48,26.1-66.48,66.61   c0,40.33,30.43,66.43,66.48,66.43c11.88,0,23.42-2.88,33.13-8.29l15.68,17.29l18.74-15.85l-15.68-17.1   C1026.16,216.14,1031.59,201.77,1031.59,184.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M836.32,87.34V195.4h13.81v15.9h-13.81v79.69h224.65V87.34H836.32z M888.52,247.07h-23.54v-52.13h23.54V247.07   z M888.52,183.17h-23.54v-23.54h23.54V183.17z M1014.1,260.08l-15.68-17.29c-9.7,5.42-21.25,8.29-33.13,8.29   c-36.04,0-66.48-26.1-66.48-66.43c0-40.51,30.43-66.61,66.48-66.61c35.86,0,66.29,26.1,66.29,66.61c0,17.1-5.42,31.48-14.42,42.47   l15.68,17.1L1014.1,260.08z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.7,236.87v15.06H88.1V128.37h72.81v15.06h-56.67v40.17h49.5v15.24h-49.5v38.02H162.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.43,203.51v48.42h-15.6v-47.52c0-13.99-7.71-22.96-19.91-22.96c-14.88-0.18-23.85,12.37-22.42,28.51   l-0.18-0.72v42.68h-15.6v-47.52c0-14.17-7.71-22.96-18.83-22.96c-11.84,0-23.67,7.35-23.67,25.11v45.37h-15.6v-83.75h15.6v12.73   c4.3-8.97,15.06-14.53,26.9-14.53c12.19,0,22.78,6.28,27.62,17.4c7.53-14.88,20.8-17.4,29.23-17.4   C295.95,166.39,307.43,180.02,307.43,203.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.8,210.15c0,26.54-18.83,43.58-41.79,43.58c-12.55,0-24.39-5.02-29.95-14.88v53.8h-15.6V168.18h15.6v13.27   c5.56-9.68,17.75-15.06,29.77-15.06C392.79,166.39,411.8,183.79,411.8,210.15z M396.02,210.33c0-16.68-12.19-29.23-27.62-29.23   c-14.89,0-28.34,11.3-28.34,29.23c0,18.11,14.71,28.69,28.34,28.69C383.82,239.02,396.02,227.19,396.02,210.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.79,209.79c0-26.54,19.91-43.4,43.76-43.4c23.85,0,43.94,16.86,43.94,43.4s-20.08,43.94-43.94,43.94   C438.69,253.73,418.79,236.33,418.79,209.79z M490.88,209.79c0-17.22-12.91-28.69-28.34-28.69c-15.24,0-27.98,11.48-27.98,28.69   c0,17.4,12.73,29.23,27.98,29.23C477.97,239.02,490.88,227.19,490.88,209.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M641.16,168.18l-31.2,83.75h-13.09l-23.13-62.23l-22.24,62.23h-12.91l-31.92-83.75h16.86l21.34,59.54   l21.34-59.54h15.24l21.52,59.54l21.34-59.54H641.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M725.63,216.78h-68.15c2.33,14.89,13.09,22.24,27.44,22.24c10.22,0,19.73-4.3,24.39-12.73l13.63,5.38   c-7.35,14.53-22.42,22.06-38.56,22.06c-23.85,0-43.04-17.4-43.04-43.94s19.19-43.4,43.04-43.4s41.61,16.86,41.61,43.4   C725.99,212.12,725.81,214.45,725.63,216.78z M710.39,203.33c-1.97-14.35-12.2-22.24-26-22.24c-14.17,0-24.21,7.17-26.72,22.24   H710.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M791.98,169.62l-2.51,14.71c-4.48-2.15-8.97-2.87-12.2-2.87c-16.68,0-23.31,17.75-23.31,39.81v30.67h-15.78   v-83.75h15.78v19.01c4.3-14.71,12.37-20.8,23.49-20.8C783.38,166.39,789.47,168,791.98,169.62z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrayonIQLogosNegativeEmpowerIQ);
export default __webpack_public_path__ + "static/media/Crayon_iQ_logos_negative_Empower_iQ.11aa1aec7452751730cc0afb7710db81.svg";
export { ForwardRef as ReactComponent };